import '../../../App.css';
import './EventWiseProfitLossBetHistory.css';
import { useState, useEffect } from 'react';
import { Table, Pagination } from 'antd';
import { useLocation } from 'react-router-dom'
import axios from 'axios';
import Appconfig from '../../../config/config'

function EventWiseProfitLossBetHistory() {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))

    const location = useLocation();
    const { from_date, to_date, event_type, is_casino, event_id, market_id, betting_type, selection_id, user_idd } = location.state || {};

    const user_id = user_idd ? user_idd : userInfo?._id;
    const [selectedBetType, setSelectedBetType] = useState('ALL');

    const handleFilterClick = (type) => {
        setSelectedBetType(type);
    };

    const [filteredData, setFilteredData] = useState([]);
    const filteredRows = filteredData.filter(record => {
        if (selectedBetType === 'ALL') return true;
        if (selectedBetType === 'Back') return !record.is_casino && record.is_back;
        if (selectedBetType === 'Lay') return !record.is_casino && !record.is_back;
        if (selectedBetType === 'Void') return record.is_casino && record.transaction_type === 'Void';
        return true;
    });

    const [formData, setFormData] = useState({
        "user_id": user_id,
        "match_id": event_id,
        "market_id": market_id,
        "selection_id": selection_id,
        "event_type": event_type,
        "is_casino": is_casino,
        "from_date": from_date,
        "to_date": to_date,
    })


    let locale = {
        emptyText: 'No data!',
    };
    const columns = [
        {
            title: 'Sport Name',
            sorter: true,

            render: (_, record) => (
                record.event_type == 4 ?
                    (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Cricket
                        </div>
                    ) : record.event_type == 2 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Tennis
                        </div>
                    ) : record.event_type == 1 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Soccer
                        </div>
                    ) : record.event_type == 777 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            WCO Casino
                        </div>
                    ) : record.event_type == 7 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Horse Racing
                        </div>
                    ) : record.event_type == 66102 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Casino
                        </div>
                    ) : record.event_type == 4339 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Greyhound Racing
                        </div>
                    ) : record.event_type == 27979456 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Kabaddi
                        </div>
                    ) : record.event_type == 7522 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Basketball
                        </div>
                    ) : record.event_type == 2378961 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Politics
                        </div>
                    ) : record.event_type == 66101 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Virtual
                        </div>
                    ) : record.event_type == 66104 ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Lottery
                        </div>
                    ) : (
                        <div className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Casino
                        </div>
                    )
            ),
        }, {
            title: 'Event Name',
            sorter: true,

            render: (_, record) => (
                <div className='font-extrabold text-[#212529] text-[0.813rem]' >
                    {record?.event_type == 777 ? record.remarks.split('(')[0].trim() : record.event_name}
                </div>
            ),
        },
        {
            title: 'Market Name',
            sorter: true,

            render: (_, record) => (

                <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                    {record?.event_type == "777" ? record?.game_code : record?.market_name}
                </div>

            ),
        },
        {
            title: 'Selection Name',
            sorter: true,

            render: (_, record) => (
                <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                    {record?.event_type == "777" ? '-' : record?.runner_name}
                </div>
            ),
        },
        {
            title: 'Winner',
            sorter: true,

            // render: (_, record) => (
            //     <div className='font-extrabold text-[#212529] text-[0.813rem]'>
            //         {record?.event_type == "777" ? '-' : record?.runner_name}
            //     </div>
            // ),
        },
        {
            title: 'Bet Type',
            sorter: true,

            render: (_, record) => (
                record.event_type == "777" ? (
                    <div className=''>
                        {record?.transaction_type}
                    </div>
                ) :
                    record.is_back ? (
                        <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                            BACK
                        </div>
                    ) : (
                        <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                            Lay
                        </div>
                    )

            ),
        },
        {
            title: 'User Price',
            sorter: true,

            render: (_, record) => (
                <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                    {record?.event_type == "777" ? '-' : Number(record.price_val).toFixed(2)}
                </div>
            ),
        },
        {
            title: 'Amount',
            sorter: true,

            render: (_, record) => (
                <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                    {record?.event_type == "777" ? '-' : Number(record.stake).toFixed(2)}
                </div>
            ),
        },

        {
            title: 'Profit/Loss',
            dataIndex: 'name',
            sorter: true,
            render: (_, record) => (
                record?.event_type == "777" ?
                    <span className={`font-extrabold ${record.transaction_type == "Debit" ? 'text-[#ff0000]' : 'text-[#008000]'}  text-[0.813rem]`}>
                        {record?.amount?.toFixed(2)}
                    </span>
                    :
                    <span className={`font-extrabold ${record.totalPL < 0 ? 'text-[#ff0000]' : 'text-[#008000]'}  text-[0.813rem]`}>
                        {record?.totalPL?.toFixed(2)}
                    </span>
            )
        },

        {
            title: 'Place Date',
            sorter: true,
            render: (_, record) => (
                <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                    {new Date(record.createdAt).toLocaleString()}
                </div>
            ),
        },
        {
            title: 'Settle Time',
            sorter: true,
            render: (_, record) => (
                <div className='font-extrabold text-[#212529] text-[0.813rem]'>
                    {new Date(record.createdAt).toLocaleString()}
                </div>
            ),
        },
    ];

    const [data, setData] = useState([])
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    // const paginatedData = filteredData?.length > 0 && filteredData.slice(startIndex, endIndex);
    const paginatedData = filteredRows.slice(startIndex, endIndex);


    const rowStyle = (record) => {
        return {
            style: {
                backgroundColor: record.is_back ? '#72bbef' : '#faa9ba',
            },
        };
    };


    useEffect(() => {
        filterProfitLossBetHistory();
    }, [])


    const filterProfitLossBetHistory = async (e) => {

        var data = JSON.stringify(formData);

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/eventWiseAuraProfitLossBetHistoryNew`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                try {
                    console.log(response.data.resultData);
                    setFilteredData(response.data.resultData);

                } catch (e) {
                    // postErrorToslack(e.message);
                }
            })
            .catch(function (error) {
                console.log(error);
                // postErrorToslack(error.message);
            });
    }

    return (
        <section className="bet-history-section">
            <div className="bet-history-card">
                <header className="bet-history-card-header">
                    <div>
                        <h2>Bet History</h2>
                        <p>Review your event-wise betting activity.</p>
                    </div>
                </header>

                <div className="bet-history-filter">
                    <label className="bet-history-filter-option">
                        <span>All</span>
                        <input
                            type="radio"
                            name="betType"
                            value="ALL"
                            checked={selectedBetType === 'ALL'}
                            onChange={(e) => setSelectedBetType(e.target.value)}
                        />
                    </label>

                    <label className="bet-history-filter-option">
                        <span>Back</span>
                        <input
                            type="radio"
                            name="betType"
                            value="Back"
                            checked={selectedBetType === 'Back'}
                            onChange={(e) => setSelectedBetType(e.target.value)}
                        />
                    </label>

                    <label className="bet-history-filter-option">
                        <span>Lay</span>
                        <input
                            type="radio"
                            name="betType"
                            value="Lay"
                            checked={selectedBetType === 'Lay'}
                            onChange={(e) => setSelectedBetType(e.target.value)}
                        />
                    </label>

                    <label className="bet-history-filter-option">
                        <span>Void</span>
                        <input
                            type="radio"
                            name="betType"
                            value="Void"
                            checked={selectedBetType === 'Void'}
                            onChange={(e) => setSelectedBetType(e.target.value)}
                        />
                    </label>
                </div>

                <div className="bet-history-card-body">
                    <Table
                        locale={locale}
                        columns={columns}
                        className="event-pl bet-history-table"
                        bordered
                        dataSource={paginatedData}
                        onRow={(record) => rowStyle(record)}
                        pagination={false}
                        rowKey={(record, index) =>
                            record?._id || `${record?.createdAt}-${index}`
                        }
                        scroll={{ x: 1400 }}
                    />

                    <div className="bet-history-pagination">
                        <div className="bet-history-pagination-info">
                            Showing {filteredData?.length ? startIndex + 1 : 0} to{' '}
                            {Math.min(endIndex, filteredData?.length || 0)} of{' '}
                            {filteredData?.length || 0} entries
                        </div>

                        <div className="bet-history-pagination-actions">
                            <button
                                className="bet-history-page-button"
                                type="button"
                                onClick={handleFirst}
                            >
                                First
                            </button>

                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={filteredData?.length}
                                onChange={(page) => setCurrent(page)}
                                itemRender={(page, type, originalElement) => {
                                    if (type === 'prev') {
                                        return <button type="button">Previous</button>;
                                    }

                                    if (type === 'page') {
                                        return null;
                                    }

                                    if (type === 'next') {
                                        return <button type="button">Next</button>;
                                    }

                                    return originalElement;
                                }}
                                showSizeChanger={false}
                            />

                            <button
                                className="bet-history-page-button"
                                type="button"
                                onClick={handleLast}
                            >
                                Last
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default EventWiseProfitLossBetHistory;
